module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction"
    }
  }, [_vm._v("Introduction: "), _c('i', [_vm._v("Biblical Ethics and Living Wisely")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/BookOne#toc_marker-1"
    }
  }, [_c('b', [_vm._v("BOOK ONE:"), _c('br'), _vm._v(" "), _c('i', [_c('b', [_vm._v("Foundational Considerations")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part1#toc_marker-3-1"
    }
  }, [_c('b', [_vm._v("Part I: Love")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#toc_marker-3-1-1"
    }
  }, [_vm._v("1 Defining Love")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#toc_marker-3-1-2"
    }
  }, [_vm._v("2 The Objects and Conflicts of Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part2#toc_marker-3-2"
    }
  }, [_c('b', [_vm._v("Part II: Law")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch3#toc_marker-3-2-1"
    }
  }, [_vm._v("3 The Law")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch4#toc_marker-3-2-2"
    }
  }, [_vm._v("4 The Law, Christ, Salvation History and Obedience")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part3#toc_marker-3-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part III: Sin")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#toc_marker-3-3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Sin: "), _c('i', [_vm._v("Its Definition and Its Origin")])])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#toc_marker-3-3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Sin: "), _c('i', [_vm._v("Its Descriptions and Its Results")])])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part4#toc_marker-3-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part IV: Virtues and Vices")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#toc_marker-3-4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Becoming a Virtuous Person")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#toc_marker-3-4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Self-Control and Bodily Appetites; Greed and Contentment")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#toc_marker-3-4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Humility, Faith and Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part5#toc_marker-3-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part V: Ethical Alternatives")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#toc_marker-3-5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Relativism, the Social Contract and Utilitarianism")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#toc_marker-3-5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Duty Ethic, Evolutionary Ethics, and God as the Foundation for Morality")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/BookTwo#toc_marker-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("BOOK TWO:"), _c('br'), _vm._v(" "), _c('i', [_c('b', [_vm._v("Applying the Bible to Life")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part6#toc_marker-7-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part VI: God First")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12#toc_marker-7-1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 No Other Gods")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch13#toc_marker-7-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Honoring God in Speech and Rest")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part7#toc_marker-7-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part VII: Sex, Marriage and the Family")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch14#toc_marker-7-2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Foundational Considerations on Sexuality and the Purposes of Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch15#toc_marker-7-2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Violations of God’s Purposes Within Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch16#toc_marker-7-2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Nonmarital Violations of God’s Purposes for Sexuality")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch17#toc_marker-7-2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Romance, Dating and Engagement")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch18#toc_marker-7-2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 The Question of Homosexuality: "), _c('i', [_vm._v("Biblical and Scientific Considerations")])])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch19#toc_marker-7-2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 The Gay Marriage Question")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch20#toc_marker-7-2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 The Christian Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part8#toc_marker-7-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part VIII: Life Issues")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch21#toc_marker-7-3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Murder, Killing and Racism")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch22#toc_marker-7-3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Abortion and Infanticide")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch23#toc_marker-7-3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Suicide, Euthanasia and Other Medical Ethical Considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch24#toc_marker-7-3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 War and Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch25#toc_marker-7-3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 Crime and Punishment")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part9#toc_marker-7-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part IX: Integrity: "), _c('i', [_vm._v("Property and Truth")])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch26#toc_marker-7-4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Labor and Management, Work and Leisure")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch27#toc_marker-7-4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 Economic Systems, Poverty, Wealth and Theft")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch28#toc_marker-7-4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 Truth and Deception")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part10#toc_marker-7-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part X: Christians and Society")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch29#toc_marker-7-5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 Church and State")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch30#toc_marker-7-5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 Alternative Approaches to the Church-State Relationship")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch31#toc_marker-7-5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 The Roles of Church and Government")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch32#toc_marker-7-5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 Christian Engagement in Society")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part11#toc_marker-7-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part XI: Fallible Choices")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch33#toc_marker-7-6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33 Ethical Questions on Which Christians Differ")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch34#toc_marker-7-6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34 Knowing God’s Will in Matters Not Revealed in Scripture")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/afterword#toc_marker-7-6-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#toc_marker-7-6-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/nameindex#toc_marker-7-6-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Name Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/subjectindex#toc_marker-7-6-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/scriptureindex#toc_marker-7-6-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praisefor#toc_marker-7-6-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("An Introduction to Biblical Ethics")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/aboutauthors#toc_marker-7-6-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#toc_marker-7-6-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0